var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{on:{"initCart":_vm.initCart}})
}
var staticRenderFns = []

export { render, staticRenderFns }